module.exports = "<div class=\"front-page\">\n  <div class=\"title\">\n    <p>\n      Space janitor\n    </p>\n  </div>\n  <div class=\"start\">\n    <div *ngIf=\"user != null\">\n      <p routerLink=\"rooms/030\" name=\"button\">start</p>\n    </div>\n  </div>\n  <div *ngIf=\"user == null\" class=\"login\">\n    <p routerLink=\"login\">login</p>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/Guest/Desktop/Space-Janitor/src/app/front-page/front-page.component.html
// module id = ../../../../../src/app/front-page/front-page.component.html
// module chunks = main